import { render, staticRenderFns } from "./TfnSection.vue?vue&type=template&id=19f5c2d7&scoped=true&"
import script from "./TfnSection.vue?vue&type=script&lang=js&"
export * from "./TfnSection.vue?vue&type=script&lang=js&"
import style0 from "./TfnSection.vue?vue&type=style&index=0&id=19f5c2d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f5c2d7",
  null
  
)

export default component.exports